<script>
import storageService from "@/services/storage.service";
import Layout from "../../layouts/main";
import EasyDataTable from "vue3-easy-data-table";
import "vue3-easy-data-table/dist/style.css";
import axios from "axios";
import AppIcon from "@/components/shared/AppIcon.vue";
import EcuSelect from "@/components/shared/EcuSelect.vue";
import StatusChip from "@/components/shared/StatusChip.vue";
import TableFooter from "@/components/shared/TableFooter.vue";

export default {
  components: {
    Layout,
    EasyDataTable,
    AppIcon,
    EcuSelect,
    StatusChip,
    TableFooter,
  },
  data() {
    return {
      selectedStaffId: null,
      archiveStaff: false,
      editStaff: false,
      isLoadingEdit: false,
      successMessage: false,
      errorMessage: "",
      searchValueTable: "",
      selectFilterSort: null,
      roles: [
        { text: "staff", value: "staff" },
        { text: "verification officer", value: "verification officer" },
      ],
      branchs: [
        { text: "Arima", value: "Arima" },
        { text: "Barataria", value: "Barataria" },
        { text: "Chaguanas", value: "Chaguanas" },
        { text: "Port of Spain", value: "Port of Spain" },
        { text: "Sande Grande", value: "Sande Grande" },
        { text: "San Fernando", value: "San Fernando" },
        { text: "St. Joseph - La Joya", value: "St. Joseph - La Joya" },
        { text: "Tobago", value: "Tobago" },
      ],
      edit_firstName: "",
      edit_lastName: "",
      edit_email: "",
      edit_selectedRole: "staff",
      edit_selectedBranch: "Arima",
      headers: [
        { text: "Name", value: "staffname" },
        { text: "Emails", value: "staffemail" },
        { text: "Branch", value: "staffbranch" },
        { text: "Role", value: "staffrole" },
        { text: "Status", value: "staffstatus" },
        { text: "Action", value: "staffaction" },
      ],
      items: [],
      arrItem: [],
      // the list is loaded in one go, so paging happens here (see TableFooter)
      page: 1,
      rowsPerPage: 10,
    };
  },
  computed: {
    roleOptions() {
      return this.roles.map((r) => ({ value: r.value, label: r.text }));
    },
    branchOptions() {
      return this.branchs.map((b) => ({ value: b.value, label: b.text }));
    },
    pageCount() {
      return Math.max(1, Math.ceil(this.arrItem.length / this.rowsPerPage));
    },
    // never point past the last page after the list shrinks (e.g. after an unarchive)
    currentPage() {
      return Math.min(this.page, this.pageCount);
    },
    pagedItems() {
      const start = (this.currentPage - 1) * this.rowsPerPage;
      return this.arrItem.slice(start, start + this.rowsPerPage);
    },
  },
  mounted() {
    this.showdata();
  },
  created() {
    this.arrItem = this.items;
  },
  methods: {
    onRowsChange(rowsPerPage) {
      this.rowsPerPage = rowsPerPage;
      this.page = 1;
    },
    archivedTone(status) {
      return status === "Active" ? "green" : "amber";
    },
    openUnarchive(staff_id) {
      this.selectedStaffId = staff_id;
      this.archiveStaff = true;
    },
    confirmUnarchive() {
      if (!this.selectedStaffId) return;
      axios
        .post("/accounts/toggle_staff_activation/", {
          aid: this.selectedStaffId,
          verifyit: true,
          tn: storageService.getItem("accessToken"),
        })
        .then(() => {
          this.archiveStaff = false;
          this.showdata();
        })
        .catch((error) => {
          console.error("Error unarchiving staff member:", error);
        });
    },
    openEditModal(staffId) {
      this.selectedStaffId = staffId;
      this.successMessage = false;
      this.errorMessage = "";
      this.loadStaffDetails(staffId);
      this.editStaff = true;
    },
    loadStaffDetails(staffId) {
      this.isLoadingEdit = true;
      const token = storageService.getItem("accessToken");
      axios
        .post(`/accounts/get_staff_member/${staffId}`, {
          tn: token,
          token: token,
        })
        .then((response) => {
          const staff = response.data.status;
          if (staff) {
            this.edit_firstName = staff.first_name || "";
            this.edit_lastName = staff.last_name || "";
            this.edit_email = staff.email || "";
            this.edit_selectedRole = staff.role || "staff";
            this.edit_selectedBranch = staff.branch_name || "Arima";
          }
        })
        .catch((error) => {
          console.error("Error loading staff details:", error);
          this.errorMessage = "Failed to load staff details.";
        })
        .finally(() => {
          this.isLoadingEdit = false;
        });
    },
    editmember() {
      const token = storageService.getItem("accessToken");
      axios
        .post("/accounts/edit_member/", {
          staffId: this.selectedStaffId,
          email: this.edit_email,
          first_name: this.edit_firstName,
          last_name: this.edit_lastName,
          role: this.edit_selectedRole,
          branch: this.edit_selectedBranch,
          tn: token,
          token: token,
        })
        .then((response) => {
          if (response.data.msg === "Edited Successfully") {
            this.successMessage = true;
            this.showdata();
            setTimeout(() => {
              this.successMessage = false;
              this.editStaff = false;
            }, 1200);
          }
        })
        .catch((error) => {
          console.error("Error editing staff member:", error);
          this.errorMessage = "Failed to update staff member.";
        });
    },
    showdata() {
      let arrList = [];
      axios
        .get("/applications/archived_staff_member/", {
          params: { token: storageService.getItem("accessToken") },
        })
        .then((response) => {
          let responseList = Array.isArray(response.data)
            ? response.data
            : response.data && Array.isArray(response.data.results)
              ? response.data.results
              : [];
          responseList.forEach((item) => {
            let fullName = `${item.first_name || ""} ${item.last_name || ""}`.trim();
            let newItem = {
              staff_id: item.id,
              staffname: fullName || item.username || "Not Updated",
              staffemail: item.email || "N/A",
              staffbranch: item.branch_name || "N/A",
              staffrole: item.role || "N/A",
              staffstatus: item.staff_status || "Inactive",
              staffaction: "edit/delete",
            };
            arrList.push(newItem);
          });
          this.items = arrList;
          this.arrItem = arrList;
        })
        .catch((error) => {
          console.error("Error loading archived staff members:", error);
          this.arrItem = [];
        });
    },
  },
};
</script>

<template>
  <Layout>
    <section class="arch">
      <header class="ecu-page-head">
        <div>
          <h1>Archived Staff Members</h1>
          <p class="ecu-page-head__sub">Staff members who are no longer active.</p>
        </div>
        <router-link to="/staff_users" class="ecu-text-link">
          Staff members
          <AppIcon name="arrow-right" :size="16" :stroke="2.2" />
        </router-link>
      </header>

      <div class="ecu-card">
        <div class="ecu-toolbar">
          <div class="ecu-card__head">
            <span class="ecu-tile"><AppIcon name="users" :size="20" /></span>
            <h2 class="ecu-card__title">Archived Staff</h2>
          </div>
        </div>

        <div class="ecu-table-wrap">
          <EasyDataTable
            header-text-direction="center"
            :headers="headers"
            :items="pagedItems"
            :rows-per-page="rowsPerPage"
            empty-message="No archived staff members"
            theme-color="#f97316"
            hide-footer
            table-class-name="table-custom-style noWrapHeading"
          >
            <template #item-staffemail="{ staffemail }">
              <span class="ecu-nocap">{{ staffemail }}</span>
            </template>
            <template #item-staffname="{ staffname }">
              <span class="ecu-strong">{{ staffname || "Not Updated" }}</span>
            </template>
            <template #item-staffstatus="{ staffstatus }">
              <StatusChip :label="`${staffstatus}`" :tone="archivedTone(`${staffstatus}`)" />
            </template>
            <template #item-staffaction="{ staff_id }">
              <div class="ecu-actions">
                <router-link
                  :to="`/single_staff/${staff_id}`"
                  class="ecu-btn-view"
                  title="View Staff Member"
                >
                  <AppIcon name="eye" :size="16" /> View
                </router-link>
                <button
                  type="button"
                  class="ecu-btn-view"
                  title="Edit Staff Member"
                  @click="openEditModal(staff_id)"
                >
                  <AppIcon name="edit" :size="16" /> Edit
                </button>
                <button
                  type="button"
                  class="ecu-btn-view ecu-btn-view--solid"
                  title="Unarchive Staff Member"
                  @click="openUnarchive(staff_id)"
                >
                  <AppIcon name="refresh" :size="16" /> Unarchive
                </button>
              </div>
            </template>
          </EasyDataTable>
        </div>

        <TableFooter
          :page="currentPage"
          :rows-per-page="rowsPerPage"
          :total="arrItem.length"
          @update:page="page = $event"
          @update:rowsPerPage="onRowsChange"
        />

        <b-modal
          title="Un Archive Staff Member"
          v-model="archiveStaff"
          hide-footer
          centered
        >
          <div class="ecu-m-confirm">
            <span class="ecu-m-confirm__icon"><AppIcon name="refresh" :size="28" /></span>
            <h5>Do you really want to unarchive<br />this staff member?</h5>
            <p>The staff member will be set back to Active.</p>
            <div class="ecu-m-actions ecu-m-actions--center">
              <button class="ecu-m-btn ecu-m-btn--ghost" type="button" @click="archiveStaff = false">
                No
              </button>
              <button class="ecu-m-btn" type="button" @click="confirmUnarchive">Yes</button>
            </div>
          </div>
        </b-modal>

        <b-modal
          title="Edit Staff Member"
          v-model="editStaff"
          hide-footer
          centered
        >
          <div v-if="isLoadingEdit" class="ecu-m-loading" role="status" aria-label="Loading">
            <span></span>
          </div>
          <form v-else class="ecu-m-form" @submit.prevent="editmember()">
            <p v-if="successMessage" class="ecu-m-alert ecu-m-alert--success">
              <AppIcon name="check-circle" :size="18" />
              Successfully edited. Updating list...
            </p>
            <p v-if="errorMessage" class="ecu-m-alert ecu-m-alert--error">
              <AppIcon name="alert" :size="18" />
              {{ errorMessage }}
            </p>
            <div class="ecu-m-grid">
        <div class="ecu-m-field">
          <label class="ecu-m-label">First Name</label>
          <input id="arch-first" v-model="edit_firstName" type="text" class="ecu-m-input" placeholder="First Name" required />
        </div>
        <div class="ecu-m-field">
          <label class="ecu-m-label">Last Name</label>
          <input id="arch-last" v-model="edit_lastName" type="text" class="ecu-m-input" placeholder="Last Name" required />
        </div>
        <div class="ecu-m-field">
          <label class="ecu-m-label">Email</label>
          <input id="arch-email" v-model="edit_email" type="email" class="ecu-m-input" placeholder="Email" disabled />
        </div>
        <div class="ecu-m-field">
          <label class="ecu-m-label">Role</label>
          <EcuSelect v-model="edit_selectedRole" :options="roleOptions" aria-label="Role" />
        </div>
        <div class="ecu-m-field ecu-m-field--wide">
          <label class="ecu-m-label">Branch Name</label>
          <EcuSelect v-model="edit_selectedBranch" :options="branchOptions" aria-label="Branch name" />
        </div>
            </div>
            <div class="ecu-m-actions">
              <button type="button" class="ecu-m-btn ecu-m-btn--ghost" @click="editStaff = false">
                Cancel
              </button>
              <button type="submit" class="ecu-m-btn">Save Changes</button>
            </div>
          </form>
        </b-modal>
      </div>
    </section>
  </Layout>
</template>

<style scoped>
.arch {
  display: flex;
  flex-direction: column;
  gap: 22px;
}
.arch .ecu-page-head {
  margin-bottom: 0;
}
.arch .ecu-card {
  padding: 22px 22px 18px;
}
.arch .ecu-toolbar .ecu-tile {
  background: transparent;
}
@media (max-width: 767px) {
  .arch .ecu-card {
    padding: 16px 14px 14px;
  }
}
</style>